'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CardHeader", {
    enumerable: true,
    get: function() {
        return CardHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCardHeader = require("./useCardHeader");
const _renderCardHeader = require("./renderCardHeader");
const _useCardHeaderStylesstyles = require("./useCardHeaderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CardHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCardHeader.useCardHeader_unstable)(props, ref);
    (0, _useCardHeaderStylesstyles.useCardHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCardHeaderStyles_unstable')(state);
    return (0, _renderCardHeader.renderCardHeader_unstable)(state);
});
CardHeader.displayName = 'CardHeader';
